import { htmlElem } from '../utils/globals';
import AttachSwipeEvent from '../utils/attachSwipeEvent';
import { protectedPages } from '../utils/protectedPages';

const fadeInClass = 'fade-in';

const modal = () => {
    const wrapper = htmlElem.querySelector('.content');
    const images = wrapper.querySelectorAll('img');
    const modal = 'modal';
    const modalBackdrop = htmlElem.querySelector(`.${modal}__backdrop`);
    const modalElem = htmlElem.querySelector(`.${modal}`);
    const modalInner = modalElem.querySelector(`.${modal}__inner`);
    const closeClass = `${modal}__close`;
    const previousClass = `${modal}__previous`;
    const nextClass = `${modal}__next`;
    let isModalOpen = false;
    let currentIndex = 0;
    let arrImages = [];
    const excludedPages = [
        'art',
    ];
    const restrictedPages = protectedPages.concat(excludedPages);
    const arrPaths = document.location.pathname.split('/');
    const primaryDir = arrPaths[1];

    if (!restrictedPages.includes(primaryDir)) {
        images.forEach((item, index) => {
            let src = item.getAttribute('src');
            arrImages.push(src);
            item.addEventListener('click', () => {
                openModal();
                currentIndex = index;
                const template = `
                    <img src=${src} class=${fadeInClass} />
                `;
                modalInner.insertAdjacentHTML('beforeend', template);
                setClosePosition();
            });
        });
    }

    document.addEventListener('click', (event) => {
        if (event.target.classList.contains(previousClass)) {
            getPreviousImage();
        }
    });

    document.addEventListener('click', (event) => {
        if (event.target.classList.contains(nextClass)) {
           getNextImage();
        }
    });

    const swiper = () => new AttachSwipeEvent({
        onLeft() {
            getPreviousImage();
        },
        onRight() {
            getNextImage()
        }
    });

    document.addEventListener('click', (event) => {
        if (
            event.target.classList.contains(closeClass) ||
            event.target.classList.contains(`${modal}__image`)
        ) {
            closeModal();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (!isModalOpen) {
            return;
        }
        if (event.key === 'Escape') {
            closeModal();
        } 
        if (event.key === 'ArrowLeft') {
            getPreviousImage();
        }
        if (event.key === 'ArrowRight') {
            getNextImage();
        }
    });

    const getPreviousImage = () => {
        if (!isModalOpen) {
            return;
        }
        if (currentIndex === 0) {
            currentIndex = arrImages.length - 1;
        } else {
                currentIndex -= 1;
        }
        appendModal(arrImages, currentIndex);
    }

    const getNextImage = () => {
        if (!isModalOpen) {
            return;
        }
        if (currentIndex === arrImages.length -1) {
            currentIndex = 0;
        } else {
            currentIndex += 1;
        }
        appendModal(arrImages, currentIndex);
    }

    const openModal = () => {
        isModalOpen = true;
        modalBackdrop.classList.add(`${modal}__backdrop--show`);
        modalElem.classList.add(`${modal}--show`);
    }

    const closeModal = () => {
        isModalOpen = false;
        modalBackdrop.classList.remove(`${modal}__backdrop--show`);
        modalElem.classList.remove(`${modal}--show`);
        modalInner.replaceChildren();
    }

    const appendModal = (arr, index) => {
        modalInner.replaceChildren();
        const template = `
            <img src=${arr[index]} class=${fadeInClass} />
        `;
        modalInner.insertAdjacentHTML('beforeend', template);
        setClosePosition();
    }

    swiper();

    const setClosePosition = () => {
        const element = modalInner.querySelector('img');
        if (element) {
            element.onload = () => {
                const top = element.offsetTop;
                const right = element.offsetLeft;
                const closeButton = modalElem.querySelector(`.${closeClass}`);
                closeButton.style.top = `${top - 35}px`;
                closeButton.style.right = `${right - 35}px`;
                closeButton.classList.add(fadeInClass);
            }
        }
    }

    window.addEventListener('resize', () => {
        setClosePosition();
    });
}

export {
    modal
}